class OpenDialog extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._openDialog.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

  }

  connectedCallback() {
    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this.removeEventListener('keydown', this._onKeyDown);
  }

  get suggestionElement() {
    return this.getAttribute('data-suggestion');
  }

  get suggestionOne() {
    return this.getAttribute('data-suggestion-1');
  }

  get suggestionTwo() {
    return this.getAttribute('data-suggestion-2');
  }

  get suggestionThree() {
    return this.getAttribute('data-suggestion-3');
  }

  get dialogOne() {
    return this.getAttribute('data-diag-1');
  }

  get dialogTwo() {
    return this.getAttribute('data-diag-2');
  }

  get dialogThree() {
    return this.getAttribute('data-diag-3');
  }

  _onKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this._openDialog();
    }
  }

  _openDialog() {
    let type;
    let payload = {};

    switch (this.suggestionElement) {
      case "START_DIAGNOSTIC":
        type = "START_DIAGNOSTIC";
        break;

      case "OPEN_WITH_SUGGESTIONS":
        type = "OPEN_WITH_SUGGESTIONS";

        const suggestions = [];

        if (this.suggestionOne) {
          suggestions.push({
            question: this.suggestionOne,
            ...(this.dialogOne === "true" && { type: "personal_shopper" })
          });
        }

        if (this.suggestionTwo) {
          suggestions.push({
            question: this.suggestionTwo,
            ...(this.dialogTwo === "true" && { type: "personal_shopper" })
          });
        }

        if (this.suggestionThree) {
          suggestions.push({
            question: this.suggestionThree,
            ...(this.dialogThree === "true" && { type: "personal_shopper" })
          });
        }

        payload = { suggestions };
        break;

      default:
        type = "GENERIC_QUESTION";
        payload = { question: this.suggestionElement };
        break;
    }

    const openDiagEvent = new CustomEvent('enableDialogAssistantEvent', {
      detail: {
        type,
        payload,
      },
      bubbles: true,
      composed: true,
    });

    window.dispatchEvent(openDiagEvent);
  }
}

export class inspireMeSidebar extends HTMLElement {
  constructor() {
    super();

    setTimeout(() => {
      this.sidebarOverlay = document.querySelector('.inspire-me-sidebar__overlay');
      this.attachEventListeners();
    }, 100);
  }

  attachEventListeners() {
    this.openDrawerButton.addEventListener('click', this.openDrawer.bind(this));
    this.sidebarOverlay.addEventListener('click', this.closeDrawer.bind(this));
    Array.from(this.closeDrawerButton).forEach((button) => {
      button.addEventListener('click', this.closeDrawer.bind(this));
    })
  }

  // Handle Drawer
  get openDrawerButton() {
    return document.querySelector('[aria-controls="inspire-me-sidebar-open"]');
  }

  get closeDrawerButton() {
    return this.querySelectorAll('[aria-controls="inspire-me-sidebar-close"]');
  }

  openDrawer() {
    this.setAttribute('aria-expanded', 'true');
    this.sidebarOverlay.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.setAttribute('aria-expanded', 'false');
    this.sidebarOverlay.classList.remove('active');
    document.documentElement.style.overflow = '';
  }
}

if (!window.customElements.get('open-dialog')) {
  window.customElements.define('open-dialog', OpenDialog);
}
if (!window.customElements.get('inspire-me-sidebar')) {
  window.customElements.define('inspire-me-sidebar', inspireMeSidebar);
}